import PassengerDataResponse, {
  PassengerDataResponseDataPassenger,
  PassengerDataResponseDataPassengerAddress,
  PassengerDataResponseDataPassengerAvailableDispatch,
  PassengerDataResponseDataPassengerDispatch,
} from "../../../api/raily/passenger/data/passenger-data.response";
import PassengerData, {
  PassengerDataPassenger,
  PassengerDataPassengerAddress,
  PassengerDataPassengerAvailableDispatch,
  PassengerDataPassengerDispatch,
} from "./passenger-data";

const createPassengerAddress = (
  address: PassengerDataResponseDataPassengerAddress,
): PassengerDataPassengerAddress => {
  return {
    apartment: address.apartment,
    country: address.country,
    description: address.description,
    houseNo: address.houseNo,
    lat: address.lat,
    lon: address.lon,
    street: address.street,
    town: address.town,
    zipCode: address.zipCode,
  };
};

const createPassengerAddresses = (
  addresses: PassengerDataResponseDataPassengerAddress[],
): PassengerDataPassengerAddress[] => {
  return addresses.map(createPassengerAddress);
};

const createAvailableDispatch = (
  availableDispatch: PassengerDataResponseDataPassengerAvailableDispatch,
): PassengerDataPassengerAvailableDispatch => {
  return {
    addressString: availableDispatch.addressString,
    displayName: availableDispatch.displayName,
    id: availableDispatch.id,
  };
};

const createAvailableDispatches = (
  availableDispatches: PassengerDataResponseDataPassengerAvailableDispatch[],
): PassengerDataPassengerAvailableDispatch[] => {
  return availableDispatches.map(createAvailableDispatch);
};

const createDispatch = (
  dispatch: PassengerDataResponseDataPassengerDispatch,
): PassengerDataPassengerDispatch => {
  return {
    addressString: dispatch.addressString,
    displayName: dispatch.displayName,
    id: dispatch.id,
  };
};

const createDispatches = (
  dispatches: PassengerDataResponseDataPassengerDispatch[],
): PassengerDataPassengerDispatch[] => {
  return dispatches.map(createDispatch);
};

const createPassenger = (
  passenger: PassengerDataResponseDataPassenger,
): PassengerDataPassenger => {
  return {
    addresses: createPassengerAddresses(passenger.addresses),
    availableDispatches: createAvailableDispatches(
      passenger.availableDispatches,
    ),
    dispatches: createDispatches(passenger.dispatches),
  };
};

const create = (response: PassengerDataResponse): PassengerData => {
  const data = response.data;

  return {
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    mobilePrimary: data.mobilePrimary,
    mobilePrimaryPrefix: data.mobilePrimaryPrefix,
    mobileSecondary: data.mobileSecondary,
    mobileSecondaryPrefix: data.mobileSecondaryPrefix,
    passenger: createPassenger(data.passenger),
  };
};

const passengerDataFactory = {
  create,
};

export default passengerDataFactory;
